<template>
  <div class="map-legend-layer">
    <div class="map-legend-layer-title" @click="toggleCollapse(layer)">
      <div class="flex align-items-center">
        <i class="fa fa-clone mr-1"/> {{ layer.title }}
      </div>
      <i v-if="isCollapsed(layer)" class="fa fa-angle-right"/>
      <i v-else class="fa fa-angle-down"/>
    </div>
    <div v-if="!isCollapsed(layer)">
      <MapLegendItem v-for="(item) in layer.properties.legend" :item="item" :layer="layer"/>
    </div>
  </div>
  <template v-if="layer?.children?.length">
    <template v-for="(childLayer) in layer.children">
      <MapLegendLayer
        v-if="childLayer?.properties?.legend?.length"
        :collapsed-layers="collapsedLayers"
        :layer="childLayer"
        @toggle="toggleCollapse"
      />
    </template>
  </template>
</template>

<script>
import MapLegendItem from "@/components/content/MapLegendItem.vue";

export default {
  name: "MapLegendLayer",
  components: {MapLegendItem},
  props: {
    layer: {
      type: Object,
      required: true
    },
    collapsedLayers: {
      type: Array,
      required: true
    }
  },
  methods: {
    isCollapsed(layer) {
      return this.collapsedLayers.indexOf(layer.documentId) > -1
    },
    toggleCollapse(layer) {
      this.$emit('toggle', layer)
    }
  }
}
</script>

<style scoped lang="scss">
.map-legend-layer {
  margin-bottom: 5px;
  padding: 5px;

  .map-legend-layer-title {
    font-style: italic;
    padding: 5px 5px;
    cursor: pointer;
    user-select: none;
    background: var(--surface-50);
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  :deep(.map-legend-item) {
    padding: 0 5px;

    .map-legend-item-group {
      font-weight: bold;
      color: var(--primary-color);
      margin: 3px 0;
    }

    .map-legend-item-symbol {
      color: var(--text-color);
      line-height: 1.1;
      margin: 10px 0;
    }
  }
}
</style>
